import { render, staticRenderFns } from "./RecommendCourseComponent.vue?vue&type=template&id=2c8af26a&scoped=true&"
import script from "./RecommendCourseComponent.vue?vue&type=script&lang=js&"
export * from "./RecommendCourseComponent.vue?vue&type=script&lang=js&"
import style0 from "./RecommendCourseComponent.vue?vue&type=style&index=0&id=2c8af26a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8af26a",
  null
  
)

export default component.exports